const managerImage = [
  {
    title: "PRESIDENT DIRECTOR",
    imgSrc: "/manager/asrianto.jpg",
    description: "ASRIANTO",
  },
  {
    title: "PRESIDENT COMMISSIONER",
    imgSrc: "/manager/komut.jpg",
    description: "ZULITA MAEHARTIN",
  },
  {
    title: "DIRECTOR",
    imgSrc: "/manager/rodi.jpg",
    description: "RODI WARDANA",
  },
  {
    title: "COMMISSIONER",
    imgSrc: "/manager/mursal.jpg",
    description: "MURSAL",
  },
  {
    title: "MARKETING DIVISION SRIKANDI",
    imgSrc: "/manager/anik.jpg",
    description: "ZUL FITRIANI TRI MAEHARTIN",
  },
  {
    title: "HUMAN RESOURCE MANAGER",
    imgSrc: "/manager/firdaus.jpg",
    description: "MUHAMMAD FIRDAUS KHUTBI",
  },
  {
    title: "FINANCE MANAGER",
    imgSrc: "/manager/khaliq.jpg",
    description: "RAPIUL KHALIQ",
  },
  {
    title: "MARKETING MANAGER",
    imgSrc: "/manager/Karti.jpg",
    description: "KARTI",
  },
  {
    title: "DIVISION IT",
    imgSrc: "/manager/nova.jpg",
    description: "MUHAMAD HALIMUDIN NOVA",
  },
  {
    title: "MARKETING DIVISION",
    imgSrc: "/manager/SALEH.jpg",
    description: "MUHAMMAD SALEH",
  },
  {
    title: "INTERNATIONAL JOB AFFAIR",
    imgSrc: "/manager/farid.jpg",
    description: "FARID",
  },
  {
    title: "INTERNATIONAL JOB AFFAIR",
    imgSrc: "/manager/arianti.jpg",
    description: "ARIANTI",
  },
  {
    title: "ADMINISTRATION",
    imgSrc: "/manager/ika.jpg",
    description: "MONIKA MAYADIANA PUTRI",
  },
];

export default managerImage;
